import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "el",
    fallbackLng: "el",
    debug: true,
    supportedLngs: ["el", "en", "bg", "srb", "ro"],
    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: process.env.PUBLIC_URL + "/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
